var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6945 23.2219L17.5852 16.1126C18.9623 14.4116 19.7915 12.2501 19.7915 9.896C19.7915 4.4398 15.3519 0.000244141 9.8957 0.000244141C4.43951 0.000244141 0 4.43975 0 9.89595C0 15.3521 4.43956 19.7917 9.89575 19.7917C12.2499 19.7917 14.4113 18.9626 16.1123 17.5855L23.2216 24.6948C23.4248 24.8979 23.6914 25 23.9581 25C24.2248 25 24.4915 24.8979 24.6946 24.6948C25.1019 24.2875 25.1019 23.6292 24.6945 23.2219ZM9.89575 17.7084C5.58745 17.7084 2.08333 14.2043 2.08333 9.89595C2.08333 5.58764 5.58745 2.08352 9.89575 2.08352C14.2041 2.08352 17.7082 5.58764 17.7082 9.89595C17.7082 14.2043 14.204 17.7084 9.89575 17.7084Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.2ccbf603d7016f7b48a481275d7ab56f.svg";
export { ForwardRef as ReactComponent };